import { useEffect, useRef } from 'react';

type CanvasPortalProperties = {
  /** use this function to do whatever you want with the canvas. */
  run: (canvas: HTMLCanvasElement) => void;
  /** optional callback ref for the canvas element */
  canvasRef?: (canvas: HTMLCanvasElement | null) => void;
};
/**
 * A React Component that renders a canvas and delegates all further handling to a function.
 *
 * Canvas drawing API runs outside the DOM, so there is little benefit to React.
 *
 * This helper Component can be used to place a purely JavaScript canvas view inside a React Component.
 */
const CanvasPortal = ({ run, canvasRef }: CanvasPortalProperties) => {
  const ref = useRef<HTMLCanvasElement>(null);
  useEffect(() => {
    const { current: canvas } = ref;
    if (!canvas) {
      return;
    }
    run(canvas);
    canvasRef?.(canvas);
  }, [run, canvasRef]);
  return <canvas ref={ref} />;
};

export { CanvasPortal };
